import { Weights, OpportunityScore } from '../types/opportunity';
import { Place } from '../types';

export interface PendingBenchmarkData {
  selectedPlace: Place;
  peerPlaces: Place[];
  activeTab: string;
}

export interface PendingAssessmentData {
  answers?: Record<number, string>;
  currentDimension?: number;
  weights?: Weights;
  scoredOpportunities?: OpportunityScore[];
  returnTo: string;
  benchmarkData?: PendingBenchmarkData;
}

export const storePendingAssessment = (data: PendingAssessmentData): void => {
  sessionStorage.setItem('pendingAssessment', JSON.stringify(data));
};

export const getPendingAssessment = (): PendingAssessmentData | null => {
  const stored = sessionStorage.getItem('pendingAssessment');
  return stored ? JSON.parse(stored) : null;
};

export const clearPendingAssessment = (): void => {
  sessionStorage.removeItem('pendingAssessment');
};